import { render, staticRenderFns } from "./DTCPinpointTest.vue?vue&type=template&id=3bf1d570"
import script from "./DTCPinpointTest.vue?vue&type=script&lang=js"
export * from "./DTCPinpointTest.vue?vue&type=script&lang=js"
import style0 from "./DTCPinpointTest.vue?vue&type=style&index=0&id=3bf1d570&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports